<template>
  <GeojsonLayer
    v-if="visible"
    :before="before"
    :sourceId="sourceId"
    :layer="layer"
    :source="usageSource"
  />
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import GeojsonLayer from '@/components/map/mapbox-layers/GeojsonLayer.vue'
import { MAPVIEW_PREFIX, PLANVIEW_PREFIX } from '@/store/module-prefixes'

export default {
  name: 'LayerHeatmap01',
  components: {
    GeojsonLayer
  },
  props: {
    before: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      layerId: 'layer-heatmap-01',
      sourceId: 'source-heatmap-01',
      paint: {
        'heatmap-weight': [
          'interpolate',
          ['linear'],
          ['zoom'],
          17,
          [
            'match',
            ['get', 'Signal_Lev'],
            [20, 21, 22, 23, 24, 25, 26, 27, 28, 29],
            0.2,
            [30, 31, 32, 33, 34, 35, 36, 37, 38, 39],
            0.3,
            [40, 41, 42, 43, 44, 45, 46, 47, 48, 49],
            0.4,
            [50, 51, 52, 53, 54, 55, 56, 57, 58, 59],
            0.5,
            [60, 61, 62, 63, 64, 65, 66, 67, 68, 69],
            0.6,
            [70, 71, 72, 73, 74, 75, 76, 77, 78, 79],
            0.7,
            [80, 81, 82, 83, 84, 85, 86, 87, 88, 89],
            0.8,
            [90, 91, 92, 93, 94],
            0.9,
            0.3
          ],
          22.1,
          [
            'match',
            ['get', 'Signal_Lev'],
            [20, 21, 22, 23, 24, 25, 26, 27, 28, 29],
            3,
            [30, 31, 32, 33, 34, 35, 36, 37, 38, 39],
            4,
            [40, 41, 42, 43, 44, 45, 46, 47, 48, 49],
            5,
            [50, 51, 52, 53, 54, 55, 56, 57, 58, 59],
            6,
            [60, 61, 62, 63, 64, 65, 66, 67, 68, 69],
            7,
            [70, 71, 72, 73, 74, 75, 76, 77, 78, 79],
            8,
            [80, 81, 82, 83, 84, 85, 86, 87, 88, 89],
            9,
            [90, 91, 92, 93, 94],
            10,
            4
          ]
        ],
        'heatmap-intensity': 0.003,
        'heatmap-color': [
          'interpolate',
          ['linear'],
          ['heatmap-density'],
          0,
          'rgba(0, 0, 255, 0)',
          0.1,
          'hsl(225, 61%, 58%)',
          0.3,
          'hsl(180, 78%, 49%)',
          0.5,
          'hsl(120, 83%, 51%)',
          0.7,
          'hsl(60, 84%, 49%)',
          1,
          'hsl(0, 91%, 48%)'
        ],
        'heatmap-radius': [
          'interpolate',
          ['linear'],
          ['zoom'],
          17,
          [
            'match',
            ['get', 'Signal_Lev'],
            [20, 21, 22, 23, 24, 25, 26, 27, 28, 29],
            1,
            [30, 31, 32, 33, 34, 35, 36, 37, 38, 39],
            1,
            [40, 41, 42, 43, 44, 45, 46, 47, 48, 49],
            2,
            [50, 51, 52, 53, 54, 55, 56, 57, 58, 59],
            3,
            [60, 61, 62, 63, 64, 65, 66, 67, 68, 69],
            4,
            [70, 71, 72, 73, 74, 75, 76, 77, 78, 79],
            5,
            [80, 81, 82, 83, 84, 85, 86, 87, 88, 89],
            6,
            [90, 91, 92, 93, 94],
            7,
            1
          ],
          22.1,
          [
            'match',
            ['get', 'Signal_Lev'],
            [20, 21, 22, 23, 24, 25, 26, 27, 28, 29],
            50,
            [30, 31, 32, 33, 34, 35, 36, 37, 38, 39],
            75,
            [40, 41, 42, 43, 44, 45, 46, 47, 48, 49],
            100,
            [50, 51, 52, 53, 54, 55, 56, 57, 58, 59],
            150,
            [60, 61, 62, 63, 64, 65, 66, 67, 68, 69],
            250,
            [70, 71, 72, 73, 74, 75, 76, 77, 78, 79],
            350,
            [80, 81, 82, 83, 84, 85, 86, 87, 88, 89],
            400,
            [90, 91, 92, 93, 94],
            450,
            50
          ]
        ],
        'heatmap-opacity': 0.69
      },
      sourceLayer: '709333890242998272_level_1-5i89xz',
      sourceUrl: 'mapbox://marcuslundh.7retgyn2'
    }
  },
  computed: {
    layer() {
      return {
        id: this.layerId,
        type: 'heatmap',
        'source-layer': this.sourceLayer,
        minzoom: 15,
        maxzoom: 22.1,
        paint: this.paint
      }
    },
    usageSource() {
      return {
        type: 'vector',
        url: this.sourceUrl
      }
    },
    visible() {
      return (
        this.isSensordataShowing &&
        this.isPlanviewShowing &&
        this.currentSensordataType === 'wifi' &&
        this.selectedBuilding.id === '709333890242998272' &&
        this.selectedLevelId === '709333893824933888'
      )
    },
    ...mapState(PLANVIEW_PREFIX, {
      isSensordataShowing: (state) => state.isSensordataShowing,
      currentSensordataType: (state) => state.currentSensordataType
    }),
    ...mapState(MAPVIEW_PREFIX, {
      selectedBuilding: (state) => state.selectedBuilding
    }),
    ...mapGetters({
      isPlanviewShowing: 'isPlanviewShowing',
      selectedLevelId: 'selectedLevelId'
    })
  }
}
</script>

<style scoped></style>
